import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default forwardRef((props, ref) => {
  const [date, setDate] = useState(null);
  const pickerRef = useRef();

  const onDateChanged = (selectedDate) => {
    setDate(selectedDate);
    props.onDateChanged(selectedDate);
  };

  useImperativeHandle(ref, () => ({
    getDate() {
      return date;
    },
    setDate(d) {
      setDate(d);
    },
    setInputPlaceholder(placeholder) {
      const input = pickerRef.current?.input;
      if (input) input.setAttribute('placeholder', placeholder);
    },
    setInputAriaLabel(label) {
      const input = pickerRef.current?.input;
      if (input) input.setAttribute('aria-label', label);
    },
  }));

  return (
    <div className="ag-input-wrapper custom-date-filter" role="presentation">
      <DatePicker
        ref={pickerRef}
        dateFormat="dd/MM/yyyy"
        selected={date}
        onChange={onDateChanged}
        className="ag-input-field-input ag-text-field-input"
        wrapperClassName="w-100"
        popperClassName="ag-custom-component-popup"
        popperProps={{ strategy: 'fixed' }}
      />
    </div>
  );
});
